export const WarehouseModel = {
    id: -1,
    productId: -1,
    productName: '',
    invoice: '',
    invoiceDate: '',
    partnerId: -1,
    price: 0,
    amount: 0,
    expiredDate: ''
};
